import { render, staticRenderFns } from "./InputVideo.vue?vue&type=template&id=c83cb7ac&scoped=true"
import script from "./InputVideo.vue?vue&type=script&lang=js"
export * from "./InputVideo.vue?vue&type=script&lang=js"
import style0 from "./InputVideo.vue?vue&type=style&index=0&id=c83cb7ac&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83cb7ac",
  null
  
)

export default component.exports